



































































































































































































































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator'
import { RawLocation } from 'vue-router'
import { GetterCart, MutationCart } from '@/store/cart'
import { MutationSnackbar, SnackbarEntry } from '@/store/snackbar'
import { DialogEntry, MutationDialog } from '@/store/dialog'
import { ProductItem } from '@/store/product'

export interface MenuItem {
  title: string
  titleShort: string
  icon: string
  route: RawLocation | string
  exact?: boolean
}

@Component
export default class HeaderMenu extends Vue {
  menuItems: MenuItem[] = [
    {
      title: 'Sports',
      titleShort: 'Sports',
      icon: 'mdi-pencil',
      route: { name: 'Sports' }
    },
    {
      title: 'Textiles',
      titleShort: 'Textiles',
      icon: 'mdi-pencil',
      route: { name: 'Textiles' }
    },
    {
      title: 'Revêtements',
      titleShort: 'Revêt.',
      icon: 'mdi-eye-outline',
      route: { name: 'Revetements' }
    },
    {
      title: 'Bois',
      titleShort: 'Bois',
      icon: 'mdi-podium',
      route: { name: 'Bois' }
    },
    {
      title: 'Accessoires',
      titleShort: 'Accessoires',
      icon: 'mdi-podium',
      route: { name: 'Accessoires' }
    },
    {
      title: 'Textiles',
      titleShort: 'Textiles',
      icon: 'mdi-podium',
      route: { name: 'Textiles' }
    },
    {
      title: 'Chaussures',
      titleShort: 'Chaussures',
      icon: 'mdi-podium',
      route: { name: 'Chaussures' }
    },
    {
      title: 'Balles',
      titleShort: 'Balles',
      icon: 'mdi-racquetball',
      route: { name: 'Balles' }
    }
  ]

  @Prop({ type: Array, default: () => [] })
  value!: ProductItem[]

  @GetterCart
  selectedItems: ProductItem[]

  @MutationSnackbar
  setSnackbarEntry: (entry: SnackbarEntry) => void

  @MutationDialog
  setDialogEntry: (entry: DialogEntry) => void

  drawerVisible: boolean = false

  deleteProduct (product?: ProductItem, i?: number) {
    console.log('deleteProduct')
    if (product) {
      this.setDialogEntry({
        message: `Etes-vous certain de vouloir supprimer cette séance "${product.description}" ?`,
        title: 'Supprimer l article',
        trueandfalse: true,
        onOk: () => this.agreeDelete(i),
        okLabel: 'Ok',
        cancelLabel: 'Annuler'
      })
    }
  }

  productPrice (product: ProductItem): number {
    let total: number = 0

    if (product.quantite && product.prix) {
      total += product.prix * product.quantite
    }
    return total
  }

  get totalPrice (): number {
    let total = 0

    for (const product of this.selectedItems) {
      total += this.productPrice(product)
    }
    return total
  }

  get totalPriceOld (): number {
    let total = 0

    for (const product of this.selectedItems) {
      if (product.quantite && product.prix && product.prixOld) {
        total += (product.prixOld - product.prix) * product.quantite
      }
    }
    return total
  }

  async agreeDelete (i?: number) {
    try {
      if (i) {
        // Rafraichissement des données concernées
        const data = this.selectedItems
        // data.splice(i, 1)
      }
    } catch (err) {
      const response = err.response
      if (response) {
        err.__handled__ = true
        // this.failed = true
        if (response) {
          // this.statusText = response.statusText
          // this.status = response.status
          // this.messageText = response.data.message
          // this.titleText = 'Suppression Impossible'
          // if (this.failed) {
          //   this.messageText = 'Une erreur inconnue s\'est produite'
          // }
          this.setSnackbarEntry({
            icon: 'mdi-alert-circle',
            color: 'error'
            // ,
            // title: this.titleText,
            // message: this.messageText
          })
        }
      }
      throw err
    }
  }
}
